<template>
  <div class="course-shop-play">
    <div class="player">
      <div class="title">
        <span>{{ activeVideo.sectionName }}</span>
        <span @click="back">返回课程详情</span>
      </div>
      <div class="play-view">
        <div id="prism-player" class="prism-player"></div>
        <div :class="['expend', { isExpend: isExpend }]" @click="expend">
          <i v-if="!isExpend" class="el-icon-arrow-right"></i>
          <i v-else class="el-icon-arrow-left"></i>
        </div>
        <div v-show="!isExpend" class="play-menu">
          <div
            v-for="(item, index) in detail.sections"
            :key="item.sectionId"
            :class="['play-menu-item', { active: item.sectionId == sectionId }]"
            @click="toPlay(item)"
          >
            <div class="name">
              <template v-if="!item.videoId">
                <img src="@/assets/shop/video_lock_icon.png" alt=""
              /></template>
              <template v-else>
                <img
                  v-if="item.sectionId == sectionId"
                  src="@/assets/shop/video_playing_icon.png"
                  alt=""
                />
                <img v-else src="@/assets/shop/video_new_icon.png" alt="" />
              </template>
              <span
                >第<span v-show="index < 9">0</span>{{ index + 1 }}节 {{ item.sectionName }}</span
              >
            </div>
            <div class="time">{{ item.durationMinute }}分钟</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { courseShopInfo, videoPlayInfo } from '@/api/course'
import to from 'await-to'
export default {
  name: 'CourseShopPlay',
  data() {
    return {
      player: null,
      detail: {},
      productId: '',
      sectionId: '',
      activeVideo: {},
      isExpend: false,
    }
  },
  mounted() {
    this.productId = this.$route.params.productId
    this.sectionId = this.$route.query.sectionId
    this.getDetail()
  },
  methods: {
    async getDetail() {
      const [res, err] = await to(courseShopInfo({ productId: this.productId }))
      if (err) return this.$message.warning(err.msg)
      this.detail = res.data
      for (let i = 0; i < this.detail.sections.length; i++) {
        const section = this.detail.sections[i]
        if (section.sectionId == this.sectionId) {
          this.activeVideo = section
          this.activeVideo.url = await this.getPlayUrl(section.videoPlatform, section.videoId)
          this.init()
        }
      }
    },
    init() {
      // eslint-disable-next-line no-undef
      this.player = new Aliplayer({
        id: 'prism-player',
        cover: this.activeVideo.coverImageUrl,
        source: this.activeVideo.url,
        width: '100%',
        autoplay: true,
        isLive: false,
        rePlay: true,
        controlBarVisibility: 'hover',
      })
    },
    async getPlayUrl(videoPlatform, videoId) {
      const [res, err] = await to(videoPlayInfo({ videoPlatform, videoId }))
      if (err) {
        this.$message.warning(err.msg)
        return false
      }
      return res.data.videoUrl
    },
    async toPlay(item) {
      if (!item.videoId) return this.$message.warning('请先购买该课程')
      this.sectionId = item.sectionId
      this.activeVideo = item
      this.activeVideo.url = await this[
        { 0: 'getPlayUrl_ali', 2: 'getPlayUrl_huawei', 3: 'getPlayUrl_ksb' }[item.videoPlatform]
      ](item.videoId)
      this.player.loadByUrl(this.activeVideo.url)
      this.player.setCover(this.activeVideo.url)
      this.player.play()
    },
    back() {
      this.$router.go(-1)
    },
    expend() {
      this.isExpend = !this.isExpend
    },
  },
}
</script>
<style lang="scss" scoped>
.course-shop-play {
  .title {
    // width: 1200px;
    height: 70px;
    opacity: 1;
    background: #232323;
    font-size: 20px;
    color: #ffffff;
    line-height: 70px;
    padding-left: 27px;
    box-sizing: border-box;
    span {
      &:last-of-type {
        cursor: pointer;
        float: right;
        font-size: 14px;
        color: #ff7b33;
        margin-right: 336px;
      }
    }
  }
  .play-view {
    position: relative;
    // width: 1200px;
    height: 490px;
    display: flex;
    .prism-player {
      flex: 1;
      height: 100% !important;
      width: 100%;
    }
    .expend {
      cursor: pointer;
      position: absolute;
      right: 330px;
      top: 0;
      width: 21px;
      height: 490px;
      line-height: 490px;
      background: rgba(19, 19, 19, 0.6);
      i {
        font-size: 20px;
        color: #ccc;
      }
      &.isExpend {
        right: 0;
      }
    }
    .play-menu {
      width: 330px;
      height: 490px;
      box-sizing: border-box;
      background: #131313;
      padding: 0 20px;
      overflow-y: scroll;
      .play-menu-item {
        cursor: pointer;
        padding: 20px 0;
        border-bottom: 1px solid #333333;
        &.active {
          .name {
            color: #409eff;
          }
        }
        .name {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #c2c2c2;
          margin-bottom: 5px;
          img {
            width: 15px;
            height: 15px;
            margin-right: 6px;
          }
        }
        .time {
          font-size: 14px;
          color: #777777;
          padding-left: 22px;
        }
      }
    }
  }
}
</style>
